export const BUY_NOW_LOWER_HARD_CAP_FEATURE_FLAG =
  'cnl_buy_now_lower_hard_cap_feature_flag';

export const BUY_NOW_HPPM_FOR_UNRESTRICTED =
  'se_buy_now_expose_hppm_whitelisted';
export const BUY_NOW_NEW_MESSAGES = 'se_buy_now_new_messages';
export const BUY_NOW_EXPOSE_HPPM = 'se_buy_now_expose_hppm';
export const GREAT_VALUE_BADGE = 'se_buy_now_badges';

export const SELLER_INVOICES_PAGE = 'seller-invoices-page';
